// V.1.0.1 2025/08/20 11:00:00
import React from 'react';

const errorFallbackStyles = {
  padding: '20px',
  backgroundColor: '#fff0f0',
  border: '1px solid #ffc0c0',
  borderRadius: '8px',
  color: '#a04040',
  fontFamily: 'Arial, sans-serif',
  textAlign: 'center',
};

const headerStyles = {
  fontSize: '1.2em',
  fontWeight: 'bold',
  marginBottom: '10px',
};

const messageStyles = {
  fontSize: '1em',
};

const ErrorFallback = ({ error }) => {
  return (
    <div style={errorFallbackStyles}>
      <div style={headerStyles}>Something Went Wrong</div>
      <div style={messageStyles}>
        <p>This dashboard could not be loaded due to an error.</p>
        {process.env.NODE_ENV === 'development' && (
          <pre style={{ color: 'red', textAlign: 'left', whiteSpace: 'pre-wrap', wordBreak: 'break-all', marginTop: '10px' }}>
            <code>{error && error.toString()}</code>
          </pre>
        )}
      </div>
    </div>
  );
};

export default ErrorFallback;
